import { Link } from 'react-router-dom';

import './Sidebar.css';

const Sidebar = () => {

    return (

        <div className="sidebar">

            <div>

                <h2 className="logo">
                    Event Admin
                </h2>

            </div>


            <ul>

                <Link className="nav-link" to="/">
                    <li>Dashboard</li>
                </Link>

                <Link className="nav-link" to="/exhibitors">
                    <li>Exhibitors</li>
                </Link>

                <Link className="nav-link" to="/bookings">
                    <li>Bookings</li>
                </Link>

                <Link className="nav-link" to="/faq">
                    <li>FAQ</li>
                </Link>

                <Link className="nav-link" to="/schedule">
                    <li>Schedule</li>
                </Link>

                <Link className="nav-link" to="/content">
                    <li>Content</li>
                </Link>

                <Link className="nav-link" to="/settings">
                    <li>Settings</li>
                </Link>

            </ul>


            <button className="logout-btn">

                Logout

            </button>

        </div>

    );
}

export default Sidebar;